import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesValidateGeolocalizationComponent} from "./sales-validate-geolocalization.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {GeneralModule} from "../general/general.module";
import {LibraryModule} from "library";



@NgModule({
  declarations: [
    SalesValidateGeolocalizationComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    GeneralModule,
    LibraryModule
  ],
  exports: [
    SalesValidateGeolocalizationComponent
  ]
})
export class SalesValidateGeolocalizationModule { }
